<template>
  <div class="mb-4 pt-2">
    <div class="liderki-boxes mb-3">
      <div class="liderki-boxes__box kreatywna-druzynowa">
        <h4 class="liderki-boxes__box-title">Kreatywna<br/>drużynowa</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s1-kreatywna-druzynowa.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Pasje i zajawki</div>
            <div>Współpraca</div>
            <div>Budowanie społeczności</div>
            <div>Entuzjazm</div>
            <div>Odkrywanie</div>
            <div>Tworzenie</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box niezrownana-zwyciezczyni">
        <h4 class="liderki-boxes__box-title">Niezrównana<br/>zwyciężczyni</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s2-niezrownana-zwyciezczyni.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Rywalizacja</div>
            <div>Kalibracja</div>
            <div>Zwycięstwo</div>
            <div>Stawanie się lepszą</div>
            <div>Nieuznawanie autorytetów</div>
            <div>Potrzeba wolności</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box kreatorka-rozwiazan">
        <h4 class="liderki-boxes__box-title">Kreatorka<br/>rozwiązań</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s3-kreatorka-rozwiazan.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Eksperckość</div>
            <div>Zaangażowanie</div>
            <div>Innowacyjność</div>
            <div>Wolność</div>
            <div>Wewnętrzna motywacja</div>
            <div>Rozwój</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box kanapowa-menadzerka">
        <h4 class="liderki-boxes__box-title">Kanapowa<br/>menadżerka</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s4-kanapowa-menadzerka.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Jasne zasady</div>
            <div>Szacunek innych</div>
            <div>Sprawiedliwość</div>
            <div>Własne zdanie</div>
            <div>Niechęć do sytuacji kryzysowych</div>
            <div>Potrzeba docenienia</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box realizujaca-marzenia">
        <h4 class="liderki-boxes__box-title">Realizująca<br/>marzenia</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s5-realizujaca-marzenia.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Wyjątkowość</div>
            <div>Spontaniczność </div>
            <div>Radość</div>
            <div>Otwartość na zmianę</div>
            <div>Eksperymentowanie </div>
            <div>Samodzielność</div>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-secondary" @click="$emit('nextStartPage')">
      Dalej
    </button>
  </div>
</template>

<script>
export default {
  name: 'Start2',
  props: ['quiz', 'numStartPage'],
};
</script>
